import formatPrice from "./formatPrice.js";

export default function getOrderTotal({ netSales, totalWaived }) {
  return totalWaived ? formatPrice(netSales - totalWaived) : netSales;
}
